<template>
<div class="login-card">
  <div class="card-title" v-if="way!=='忘记密码'">
    <el-button :class="{ 'active': way==='登录' }" class="title" type="text" @click="switch2Login">登录</el-button>
<!--    <span class="title">/</span>-->
<!--    <el-button :class="{ 'active': way==='注册' }" class="title" type="text" @click="switch2Create">注册</el-button>-->
  </div>

  <div class="card-title" v-else>
    <span class="active">忘记密码</span>
  </div>


  <el-form
    ref="form"
    v-model="formData"
    class="form"
    label-width="0px"
  >
    <el-form-item  prop="account"  style="margin-bottom: 0">
      <el-input :placeholder="accountPlaceholder" v-model="formData.account" style="font-size: 1vw" id="account">
        <i class="code-icon icon-user" slot="prefix" style="font-size: 1vw;line-height: 3vw;margin-left: 1vw"></i>
      </el-input>
      <p class="err-msg" :class="{'err-active':createErr}" >账号/手机号/邮箱有误</p>
    </el-form-item>
    <el-form-item  prop="code" v-if="way!=='登录'" style="margin-bottom: 0">
      <el-input placeholder="输入验证码" v-model="formData.code" style="font-size: 1vw">
        <i class="code-icon icon-code" slot="prefix" style="font-size: 1vw;line-height: 3vw;margin-left: 1vw"></i>
        <el-button slot="suffix" type="text" @click="way==='注册'?getCode():getChangeCode()" :disabled="hasSend" style="font-size: 1vw;margin-top: 0.5vw;margin-right: 0.5vw">{{ codeMsg }}</el-button>
      </el-input>
      <p class="err-msg" :class="{'err-active':codeErr}" >验证码错误</p>
    </el-form-item>
    <el-form-item  prop="password" style="margin-bottom: 0">
      <el-input :placeholder="pwdPlaceholder" v-model="formData.password" id="password"  style="font-size: 1vw" :class="{'error-input':forgetErr}" ref="pwd" :type="formData.show.ps?'text':'password'" :show-password="false">
        <i class="code-icon icon-pwd" slot="prefix" style="font-size: 1vw;line-height: 3vw;margin-left: 1vw" v-if="way!=='忘记密码'"></i>
        <i class="code-icon icon-new-pwd" slot="prefix" style="font-size: 1vw;line-height: 3vw;margin-left: 1vw" v-else></i>
        <i class="el-icon-view" style="font-size: 1.5vw;line-height: 3vw;margin-right: 1vw;cursor: pointer" slot="suffix" @click="formData.show.ps=!formData.show.ps"></i>
      </el-input>
      <p class="err-msg" :class="{'err-active':loginErr}"  >账号或密码错误，请重新输入</p>
    </el-form-item>
    <el-form-item  prop="password_cpy" style="margin-bottom: 0;" v-if="way==='忘记密码'">
      <el-input placeholder="确认新密码" v-model="formData.password_cpy"  style="font-size: 1vw;position: relative" :class="{'error-input':forgetErr}" ref="pwd_cpy"  :type="formData.show.check?'text':'password'" >
        <i class="code-icon icon-check-pwd" slot="prefix" style="font-size: 1vw;line-height: 3vw;margin-left: 1vw"></i>


        <i class="el-icon-view" style="font-size: 1.5vw;line-height: 3vw;margin-right: 1vw;cursor: pointer" slot="suffix" @click="formData.show.check=!formData.show.check"></i>
      </el-input>
      <p style="margin-left: 2rem;color: #888888">密码由8位以上的数字、字母组合</p>
    </el-form-item>
  </el-form>



  <div v-if="way==='登录'"
       class="method-btn">
    <div style="margin: auto;display: flex;align-items: center;height: 60px">
      <input type="checkbox" id="check1" v-model="checked" @change="loadMsg" style="width: 0.8vw;height: 0.8vw">
      <span style="display: inline-block;line-height: 60px;margin-left: 0.5vw">记住密码</span>
    </div>
    <div style="width: 30%;height: 1px"></div>
    <div type="text" style="color: #1a8cfe;margin: auto;cursor: pointer " @click="switch2Forget" >忘记密码？</div>
  </div>






  <el-button @click="loginMethod" class="submitBtn" id="login"><span style="margin-top: 0">{{ btnMsg }}</span></el-button>
  <p style="margin: auto ;width: 7rem;font-size: 0.7rem;white-space: nowrap;" v-if="way==='注册'||way==='忘记密码'">已有账号？立即<span style="color: #1a8cfe;cursor: pointer" @click="switch2Login">登录</span></p>


  <div v-if="way==='登录'"
       class="other-way">
    <div class="flex-line">
      <div style="width: 14rem;height: 1px;background-color: #d3dce6;margin: 1rem 2rem 1rem"></div>
      <p style="width: 8rem ;white-space: nowrap;text-align: center;font-size: 1.2rem;line-height: 1rem;margin:0.5rem auto;">第三方登录</p>
      <div style="width: 14rem;height: 1px;background-color: #d3dce6;margin: 1rem 2rem  1rem"></div>
    </div>
    <div class="flex-icon">
      <div class="icon1"></div>
      <div class="icon2"></div>
      <div class="icon3"></div>
    </div>
  </div>

</div>
</template>

<script>
import { Message } from 'element-ui'
import {setHeartBeatToken, setToken} from '@/utils/auth'
import {changePwdCode, checkStatus, signUpCode} from '@/api/user'
export default {
  name: 'loginCard',
  data(){
    return{
      ip:'',
      weakPwd:/^[A-Za-z0-9]{2,25}$/,
      phoneNumber:/^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/,
      email:/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
      loading:false,
      times:60,
      codeMsg:'获取验证码',
      receiveCode:'1234',
      hasSend:false,
      btnMsg:this.$route.query.way==='注册'?'免费注册':'点击登录',
      pwdPlaceholder:'输入密码',
      accountPlaceholder:'账号/手机号/邮箱',
      checked:false,
      hb_string:'',
      loginErr:false,
      createErr:false,
      forgetErr:false,
      codeErr:false,
      timer:null,
      formData:{
        code:'',
        account:'',
        password:'',
        password_cpy:'',
        show: {
          ps:false,
          check: false,
        },
      },
      way:this.isSignIn?'登录':'注册',
      backup_pwd:'',
      backup_pwd_cpy:''
    }
  },
  props:{
    isSignIn:{
      type:Boolean,
      default:true
    },
    device:{
      type:String,
      default:'手机'
    }
  },

  watch:{
    times:function () {
      if(this.times==0){
        clearInterval(this.timer)
        this.$nextTick(()=>{
          this.codeMsg='重新发送'
          this.hasSend=false
        })
      }
      this.codeMsg='已发送'+this.times
    }
  },
  mounted () {
    console.log(navigator.userAgent.toLowerCase())
    const isDesktop = navigator.userAgent.toLowerCase().indexOf('electron')==-1?'false':'true'
    this.hb_string=isDesktop.toString()
    this.formData.account= localStorage.getItem('rem_account')=='null'?'':localStorage.getItem('rem_account')
    this.formData.password=localStorage.getItem('rem_password')=='null'?'':localStorage.getItem('rem_password')
    if(localStorage.getItem('rem_account')){
      this.checked=true
    }
  },
  created () {
    window.addEventListener('keydown',function (e){
      if(e.keyCode==13){
        document.getElementById('login').click()
      }
    })
  },
  destroyed () {
  },
  methods:{
    refreshFormData(){
      this.formData={
        code:'',
        account:'',
        password:'',
        password_cpy:'',
        show: {
          ps:false,
          check: false,
        },
      }
    },
    checkForm(step){
      let that=this
      switch (step){
        case 'account-login':{
          let account=this.formData.account
          if(account){
            if(this.phoneNumber.exec(account)||this.email.exec(account)||(account.length>2&&account.length<800)){
              let password=this.formData.password
              if(password){
                if(password.length>2&&password.length<25){
                  if(this.weakPwd.exec(password)){
                    return true
                  }
                  else{
                    that.loginErr=true
                    setTimeout(()=>{
                      that.loginErr=false
                    },1000)
                    this.formData.password=''
                    return false
                  }
                }
                else{
                  that.loginErr=true
                  setTimeout(()=>{
                    that.loginErr=false
                  },1000)
                  this.formData.password=''
                  return false
                }
              }
              else {
                that.loginErr=true
                setTimeout(()=>{
                  that.loginErr=false
                },1000)
                this.formData.password=''
                return false
              }
            }
            else{
              that.loginErr=true
              setTimeout(()=>{
                that.loginErr=false
              },1000)
              this.formData.password=''
              return false
            }
          }
          else {
            that.loginErr=true
            setTimeout(()=>{
              that.loginErr=false
            },1000)
            this.formData.password=''
            return false
          }
          break;
        }




        case 'create-account':{
          if(this.formData.code){
            if(this.formData.password.length>5){
              return true
            }
            else{
              this.forgetErr=true
              setTimeout(()=>{
                this.forgetErr=false
              },1000)
            }
          }
          else{
            that.codeErr=true
            setTimeout(()=>{
              that.codeErr=false
            },1000)
            this.formData.code=''
            return false
          }
          break;
        }
        case 'check-phone':{
          if(this.formData.account){
            if(this.phoneNumber.exec(this.formData.account)||this.email.exec(this.formData.account)){
              return true
            }
            else {
              that.createErr=true
              setTimeout(()=>{
                that.createErr=false
              },1000)
              this.formData.password=''
              return false
            }
          }
          else {
            that.createErr=true
            setTimeout(()=>{
              that.createErr=false
            },1000)
            this.formData.password=''
            return false
          }
          break
        }
        default:return true
      }
    },
    switch2Create () {
      this.way='注册'
      this.btnMsg='免费注册'
      this.accountPlaceholder='手机号/邮箱'
      this.refreshFormData()
      this.loadMsg()
    },
    switch2Login () {
      this.way='登录'
      this.btnMsg='点击登录'
      this.pwdPlaceholder='输入密码'
      this.accountPlaceholder='账号/手机号/邮箱'
      this.refreshFormData()
      this.loadMsg()
    },
    switch2Forget(){
      this.way='忘记密码'
      this.btnMsg='重置密码'
      this.pwdPlaceholder='输入新密码'
      this.accountPlaceholder='手机号/邮箱'
      this.refreshFormData()
      this.loadMsg()
    },

    getCode(){
      let that=this
            if(this.email.exec(this.formData.account)){
              let data={
                email:this.formData.account
              }
              signUpCode(data).then(res=>{
                if(res.status==='ok'){
                  this.hasSend = true
                  this.codeMsg = '发送成功'
                  this.timer = setInterval(() => {
                    this.times--
                  }, 1000)
                }
                else{
                  this.codeErr=true
                  setTimeout(()=>{
                    this.codeErr=false
                  },1000)
                }
              }).catch((e)=>{
                console.log(e)
              })
            }
            else {
              this.$message.error('请输入合法邮箱或手机号')
            }
    },

    getChangeCode(){
      console.log(123)
    if(this.email.exec(this.formData.account)){
      let data={
        email:this.formData.account
      }
      console.log(data)
      changePwdCode(data).then((res) => {
        if(res.status==='ok'){
          this.hasSend = true
          this.codeMsg = '发送成功'
          this.timer = setInterval(() => {
            this.times--
          }, 1000)
        }
        else{
          this.codeErr=true
          setTimeout(()=>{
            this.codeErr=false
          },1000)
        }
      }).catch((e) => {
        console.log(e)
      })
    }
    else{
this.$message.error('请输入合法邮箱或手机号')
    }
    },

    loginMethod(){
      if(this.way==='登录'){
        this.login()
      }
      if(this.way==='注册'){
        this.createAccount()
      }
      if(this.way==='忘记密码'){
        this.resetPwd()
      }
    },
    login(){
      if(this.checkForm('account-login')){
        let type=''
        if(this.email.exec(this.formData.account)){
          type='email'
        }
        else if(this.phoneNumber.exec(this.formData.account)){
          type='phone'
        }
        else {
          type='account'
        }
        let data={
          type:type,
          account:this.formData.account,
          password: this.formData.password,
        }

        console.log(data)
        this.$store.dispatch('User/loginSync',data).then((res)=>{
          console.log(res)
          if(res.status==='no'){
            this.loginErr=true
            setTimeout(()=>{
              this.loginErr=false
            },1000)
          }
          if(res==='noWay'){
            this.$message.warning('当前系统暂未开放对应的登陆方式，请稍后重试')
          }
          if(res.status==='ok'){
            localStorage.setItem('rem_account', this.formData.account);
            localStorage.setItem('rem_password', this.formData.password);
            let client=this.hb_string=='true'?'desktop':'web'
            console.log('try to heart beat in login method')
            checkStatus({client:client,signature:res.data['signature']}).then(r=>{
              console.log(r)
              if(r.status=='ok'){
                this.hb_string+='-'+res.data['signature']+'-'+res.data['hb_interval']
                setHeartBeatToken(this.hb_string)
                this.$emit('loginSuccess',this.formData.account)
              }
              else{
                console.log(123)
                this.$message.error('当前账号已经登陆')
              }
            })

          }
          else {
            this.$message.error(res.message)
          }
        }).catch(e=>{
           console.log('error'+e)
        })
      }
    },



    createAccount(){
      if(this.checkForm('create-account')){
        let type=''
        if(this.email.exec(this.formData.account)){
          type='email'
        }
        else if(this.phoneNumber.exec(this.formData.account)){
          type='phone'
        }
        else {
          type='account'
        }
        let data={
          type:type,
          account:this.formData.account,
          password: this.formData.password,
          code:this.formData.code
        }
        this.$store.dispatch('User/register',data).then((res)=>{
          if(res==='ok'){
this.$message.success('注册成功，请登录')
            this.refreshFormData()
            this.loadMsg()

            setTimeout(()=>{
              this.formData.account=data.account
              this.way='登录'
              this.btnMsg='点击登录'
              this.pwdPlaceholder='输入密码'
              this.accountPlaceholder='账号/手机号/邮箱'
            },300)
          }
          else{
            this.$message.error('注册失败，请检查后重试')
            this.refreshFormData()
            this.loadMsg()
          }
        }).catch(e=>{
          console.log(e)
        })


      }

    },



    resetPwd(){
      if(this.formData.code.length<=0){
        this.codeErr=true
        setTimeout(()=>{
          this.codeErr=false
        },1000)
      }
      else if(this.formData.password!==this.formData.password_cpy){
        this.forgetErr=true
        setTimeout(()=>{
          this.forgetErr=false
        },1000)
      }
      else {
        let data={
          email:this.formData.account,
          password:this.formData.password,
          code:this.formData.code
        }
        this.$store.dispatch('User/changePwd',data).then(res=>{
          if(res==='ok'){
this.$message.success('重置成功，请登录')
            this.refreshFormData()
            this.loadMsg()
            setTimeout(()=>{
              this.way='登录'
              this.btnMsg='点击登录'
              this.pwdPlaceholder='输入密码'
              this.accountPlaceholder='账号/手机号/邮箱'
            },300)
          }
          else{
            this.$message.error('重置失败，请检查后重试')
            this.refreshFormData()
            this.loadMsg()
          }
        }).catch(e=>{
          console.log(e)
        })
      }
    },


    loadMsg(){
      if(this.checked){
        localStorage.setItem('rem_account', this.formData.account);
        localStorage.setItem('rem_password', this.formData.password);
      }
      else{
        localStorage.removeItem('rem_account');
        localStorage.removeItem('rem_password');
        this.formData.account=''
        this.formData.password=''
      }
    }
  }
}
</script>

<style scoped>

.el-input--medium, /deep/ .el-input__inner {
  border-radius: 3vw;
  height: 3vw;
  position: relative;
  text-indent: 2vw;
}
.el-input--medium, /deep/ .el-input__inner::-webkit-input-placeholder{
  line-height: 3vw;
  font-size: 1vw;
  left:1.5vw;
  position: absolute;
}

.el-input--medium, /deep/ .el-input__inner::-ms-reveal{display:none;}
.login-card{
  width: 23vw;
  height: 32vw;
}
.card-title{
  margin: 0 auto 2vw;
  width: 10vw;
  height: 3vw;
  font-family: SourceHanSansCN-Regular;
  font-size: 3vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vw;
  letter-spacing: 0vw;
  color: #347cef;
  text-align: center;
  white-space: nowrap;
}
.form{
  width: 100%;
  margin: 0 auto 0;
}
.title{
  font-family: SourceHanSansCN-Regular;
  font-size: 1vw;
  font-weight: normal;
  letter-spacing: 0vw;
  color: #347cef;
}
.active{
  font-family: SourceHanSansCN-Regular;
  font-size: 2vw;
  font-weight: normal;
  letter-spacing: 0vw;
  color: #347cef;
}
.submitBtn{
  width: 100%;
  height: 3vw;
  background-image: linear-gradient(90deg, #3f34db 0%, #5280f9 100%);
  color: white;
  font-weight: 600;
  letter-spacing: 1rem;
  border-radius: 3vw;
  font-size: 1.5rem;
  font-family: test;

  text-align: center;
  line-height: 2rem;
  padding: 0px;
  margin-top: 0.5vw;
  margin-bottom: 2vw;
}
.method-btn{
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  height: 60px;
  margin: 0;
  font-size: 0.8vw;
}
.flex-line{
  display: flex;
  flex-wrap: nowrap;
  height: 1rem;
  width: 80%;
  margin:0 auto;
}
.flex-icon{
  margin: 2vw auto;
  width: 80%;
  height: 5vw;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: center;
}
.icon1{
  width: 3vw;
  height: 5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/login/QQ.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.icon2{
  width: 3vw;
  height: 5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/login/微信.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.icon3{
  width: 3vw;
  height: 5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/login/微博.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.code-icon{
  display: block;
  margin-top: 1vw;
  width: 1.4vw;
  height: 1.1vw;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.icon-code{
  background-image: url("http://data.xiyilab.com/web/main/static/login/验证码icon.png");
}
.icon-user{
  background-image: url("http://data.xiyilab.com/web/main/static/login/用户icon.png");
}
.icon-new-pwd{
  background-image: url("http://data.xiyilab.com/web/main/static/login/新密码icon.png");
}
.icon-pwd{
  background-image: url("http://data.xiyilab.com/web/main/static/login/密码icon.png");
}
.icon-check-pwd{
  background-image: url("http://data.xiyilab.com/web/main/static/login/确认密码icon.png");
}
.err-msg{
  height: 0.8vw;
  font-family: SourceHanSansCN-Regular;
  font-size: 0.8vw;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vw;
  visibility: hidden;
  color: #ff2b49;
  margin-left: 2vw;
  margin-top: 0;
  margin-bottom: 1vw;
}
.error-input{
  border: 1px red solid;
  border-radius: 3vw;
}
.err-active{
  visibility: inherit;
}
</style>
